import { routerStyxie } from '@/router/styxieBridge'

// No styxie payloads here — every page fetches through the API (see
// stores/location.js#ensureLocation and the per-tab fetches), so the bridge
// only mounts the shell.
Styxie.Initializers.OrganizationsLocations = routerStyxie({
  actions: ['index', 'media_v2', 'notifications_v2']
})

Styxie.Initializers.OrganizationsLocationsDashboard = routerStyxie({
  actions: [
    'show',
    'automation',
    'change_log',
    'edit',
    'local_posts',
    'local_post_new',
    'local_post_edit',
    'keywords',
    'keyword_new',
    'keyword_show',
    'reviews'
  ]
})
